import {
    REPLENISHMENT_SC_LIST,
    REPLENISHMENT_STOCK_LIST,
    FONE_CART_COUNT,
    ADD_FONE_PRODUCT,
    BATCH_ADD_FONE_PRODUCT,
    F1_CART_LIST,
    F1_CART_SELECTED_LOT_LIST,
    F1_DELETE_LIST,
    SUBMIT_ORDER_LIST,
    F1_ORDER_TAB_ACTIVE,
    F1_ORDER_QUANTITY,
    F1ORDER_SEARCH_FIELD,
    F1_ORDER_QUERY,
    ORDER_MORE_SUCCESS,
    ORDER_MORE_INITIAL,
    ORDER_MORE_FAILURE,
    FONE_ORDER_DETAILS,
    CANCEL_F1_ORDER,
    UPDATE_F1_ORDER,
    STOCK_MORE_SUCCESS,
    STOCK_MORE_INITIAL,
    STOCK_MORE_FAILURE,
    INVALID_SKU,
    INVENTORY_DETAILS,
    F1ORDER_DETAIL,
    SYS_DICT,
    VALID_SKU,
    PUSH_ADD_CART
} from "Actions/replenishment";
import update from 'immutability-helper';

const initialState = {
};
let payload = {}

export function replenishment(state = initialState, action) {   
    switch (action.type) {
        case REPLENISHMENT_SC_LIST:
            payload = action.payload.data

            return Object.assign({}, state, { replenishmentSCList: payload});

        case FONE_CART_COUNT:
            payload = action.payload.cartCount

            return Object.assign({}, state, { f1CartCount: payload});

        case ADD_FONE_PRODUCT:
            payload = action.payload.cartCount

            return Object.assign({}, state, { f1CartCount: payload});

        case BATCH_ADD_FONE_PRODUCT:
            payload = action.payload.cartCount

            return Object.assign({}, state, { f1CartCount: payload});
        case PUSH_ADD_CART:
            payload = action.payload.cartCount

            return Object.assign({}, state, { f1CartCount: payload});
        case F1_CART_LIST:
            payload = action.payload.data

            return Object.assign({}, state, { f1CartList: payload});

        case F1_CART_SELECTED_LOT_LIST:
            payload = action.payload.data

            return Object.assign({}, state, { f1CartSelectedLotList: payload});

        case F1_DELETE_LIST:
            payload = action.payload.data

            return Object.assign({}, state, { f1Delete: payload});

        case SUBMIT_ORDER_LIST:
            payload = action.payload.data

            return Object.assign({}, state, { submitF1Order: payload});

        case F1_ORDER_TAB_ACTIVE:
            return update(state, { tabActive: action.payload });

        case F1ORDER_SEARCH_FIELD:
            return update(state, { searchfields: action.payload });

        case F1ORDER_DETAIL:
            return update(state, { f1OrderDetails: action.payload });

        case F1_ORDER_QUANTITY:
            payload = action.payload.data

            return Object.assign({}, state, { f1OrderQuantity: payload});

        case FONE_ORDER_DETAILS:
            payload = action.payload.data

            return Object.assign({}, state, { f1OrderDetails: payload});

        case CANCEL_F1_ORDER:
            payload = action.payload.data

            return Object.assign({}, state, { f1CancelOrder: payload});

        case UPDATE_F1_ORDER:
            payload = action.payload.data

            return Object.assign({}, state, { f1UpdateOrder: payload});
        case INVENTORY_DETAILS:
            payload = action.payload.data

            return Object.assign({}, state, { skuInventoryDetails: payload});
        case SYS_DICT:
            payload = action.payload.data

            return Object.assign({}, state, { timeRangeOptions: payload});

        case ORDER_MORE_INITIAL:
        case ORDER_MORE_SUCCESS:
        case ORDER_MORE_FAILURE:
        case STOCK_MORE_INITIAL:
        case STOCK_MORE_SUCCESS:
        case STOCK_MORE_FAILURE:
        case F1_ORDER_QUERY:
        case REPLENISHMENT_STOCK_LIST:
        case INVALID_SKU:
        case VALID_SKU:   
            return {
                ...state,
                ...action.payload
            }

        default:
            return state;
    }
}
